import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import TimeoutUtility from "../../contexts/TimeoutUtility";
//import { DropDownListComponent } from "@syncfusion/ej2-react-dropdowns";
// import hello from "../../data/default_img.jpg";
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
  Page,
  Selection,
  Inject,
  Edit,
  Toolbar,
  Sort,
  Filter,
  Resize,
} from "@syncfusion/ej2-react-grids";
import { Col, Container, Row } from "react-bootstrap";
// import "jspdf-autotable";
import {
  GetAllVendorsByStore,
  CheckVenDeleteStatus,
  DeleteVendor,
} from "../../api";
import { Header, Button } from "../../components";
import "../../styles/viewCustomer.css";
import { useStateContext } from "../../contexts/ContextProvider";
import { usePromiseTracker, trackPromise } from "react-promise-tracker";
import LoadingIndicator from "../LoadingIndicator";

const Supplier = () => {
  const [AllSuppliers, setAllSuppliers] = useState("");
  const [Supplier_id, setSupplier_id] = useState("");
  const [Supplier, setSupplier] = useState("");
  const { promiseInProgress } = usePromiseTracker();
  const [loading, setloading] = useState(false);
  const {
    currentColor,
    defaultImageMode,
    imageMode,
    storeG,
    userPermID,
    userID,
    userToken,
  } = useStateContext();
  const navigate = useNavigate();

  const customerGridImage = (props) => (
    <div className="image flex gap-4">
      {!defaultImageMode || !imageMode ? (
        <div />
      ) : props.profile === null ? (
        <div className="w-100" style={{ textAlign: "center" }}>
          -
        </div>
      ) : (
        <img
          className="rounded-xl h-16"
          src={`data:image/jpeg;base64,${props.profile}`}
          alt="customer"
          width={72}
        />
      )}
    </div>
  );

  const customersGrid = [
    {
      headerText: "",
      minWidth: "100",
      width: "100",
      maxWidth: "110",
      template: customerGridImage,
      textAlign: "left",
    },
    {
      headerText: "Name",
      minWidth: "180",
      width: "320",
      maxWidth: "640",
      textAlign: "left",
      field: "name",
    },
    {
      field: "balance",
      headerText: "Balance",
      minWidth: "125",
      width: "140",
      maxWidth: "150",
      format: "C2",
      textAlign: "right",
    },
    {
      field: "phone",
      headerText: "Phone",
      minWidth: "140",
      width: "180",
      maxWidth: "220",
      textAlign: "Center",
    },
    {
      field: "website",
      headerText: "Website",
      minWidth: "140",
      width: "150",
      maxWidth: "210",
      textAlign: "left",
    },

    // {
    //   field: "contact_phone",
    //   headerText: "Contact Phone",
    //   width: "70",
    //   textAlign: "Center",
    // },
    {
      field: "contact_name",
      headerText: "Contact Name",
      minWidth: "180",
      width: "250",
      maxWidth: "320",
      textAlign: "left",
    },
    // {
    //   field: "city",
    //   headerText: "City",
    //   minWidth: "120",
    //   width: "130",
    //   maxWidth: "180",
    //   textAlign: "left",
    // },

    // {
    //   field: "attention_name",
    //   headerText: "Attention Name",
    //   minWidth: "180",
    //   width: "200",
    //   maxWidth: "240",
    //   textAlign: "left",
    // },
    // {
    //   field: "opening_balance",
    //   headerText: "Open Bal",
    //   minWidth: "140",
    //   width: "140",
    //   maxWidth: "160",
    //   format: "C2",
    //   textAlign: "right",
    // },
  ];

  const handleAddSupplierClick = async (event) => {
    event.preventDefault();
    try {
      navigate(`/Supplier/AddSupplier/${storeG.store_id}`, {
        state: { fromPage: "Supplier" },
      });
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleEditSupplierClick = async (event) => {
    event.preventDefault();
    try {
      if (Supplier_id !== "") {
        navigate(`/Supplier/EditSupplier/${Supplier_id}`);
      } else {
        alert("Please select supplier to edit.");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleViewEmployeesClick1 = async (event) => {
    event.preventDefault();
    TimeoutUtility.resetTimeout();
    try {
      if (Supplier_id !== "" && userID && userToken) {
        const resp1 = await CheckVenDeleteStatus(
          Supplier_id,
          userID,
          userToken
        );
        if (resp1.data[0].status === 0) {
          if (window.confirm(`Are you sure you want to Delete ${Supplier}?`)) {
            const response = await DeleteVendor(Supplier_id, userID, userToken);
            if (response.status === 200) {
              window.location.reload();
              alert("Supplier deleted successfully.");
            } else {
              alert("Supplier failed to delete.");
            }
          }
        } else {
          alert(
            `${Supplier} ledger transactions exist.\nIt could not be deleted.`
          );
        }
      } else {
        alert("Please select supplier to delete.");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handlePrintLedgerClick = async (event) => {
    event.preventDefault();
    try {
      if (Supplier_id !== "") {
        const custome = AllSuppliers.find(
          (cus) => cus.vendor_id === Supplier_id
        );
        navigate(`/Account/LedgerReport/${custome.account_id}`);
      } else {
        alert("Please select Supplier to print ledger.");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleViewEmployeesClick2 = async (event) => {
    event.preventDefault();
    try {
      if (Supplier_id !== "") {
        navigate(`/Supplier/ProductAssign/${Supplier_id}`);
      } else {
        alert("Please select supplier.");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleViewEmployeesClick4 = async (event) => {
    event.preventDefault();
    try {
      if (Supplier_id !== "") {
        navigate(`/supplier/ViewPurchase/${Supplier_id}`);
      } else {
        alert("Please select supplier.");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleViewSupplierClick = async (event) => {
    try {
      if (Supplier_id !== "") {
        navigate(`/Supplier/ViewSupplier/${Supplier_id}`);
      } else {
        alert("Please select supplier to view.");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleRowSelected = (args) => {
    const selectedRowData = args.data;
    setSupplier_id(selectedRowData.vendor_id);
    setSupplier(selectedRowData.name);
  };

  useEffect(() => {
    async function fetchData() {
      if (storeG !== null && storeG.store_id !== 0 && userID && userToken) {
        trackPromise(
          Promise.all([
            GetAllVendorsByStore(storeG.store_id, userID, userToken),
          ])
            .then(([result]) => {
              setAllSuppliers(result.data || []);
            })
            .catch((err) => {
              console.log(err.message);
            })
            .finally(() => {
              setloading(false);
            })
        );
      }
    }
    fetchData();
  }, [storeG, userID, userToken]);

  return (
    <div className="m-0 md:m-4 p-4 md:p-8 bg-white rounded-3xl">
      <Header category="Accounts" title="SUPPLIERS" />
      <Container fluid className="g-0 p-0 justify-end">
        <Row xs={2} className="button-row justify-content-end font-normal">
          {userPermID.includes(5026) && (
            <Col md="auto" style={{ padding: "0" }}>
              <Button
                margin="6px"
                color="white"
                bgColor={currentColor}
                text="Add"
                borderRadius="10px"
                onClick={handleAddSupplierClick}
              />
            </Col>
          )}
          {userPermID.includes(5027) && (
            <>
              <Col md="auto" style={{ padding: "0" }}>
                <Button
                  margin="6px"
                  color="white"
                  bgColor={currentColor}
                  text="Update"
                  borderRadius="10px"
                  onClick={handleEditSupplierClick}
                />
              </Col>
              <Col md="auto" style={{ padding: "0" }}>
                <Button
                  margin="6px"
                  color="white"
                  bgColor={currentColor}
                  text="Delete"
                  borderRadius="10px"
                  onClick={handleViewEmployeesClick1}
                />
              </Col>
            </>
          )}
          {userPermID.includes(5026) && (
            <Col md="auto" style={{ padding: "0" }}>
              <Button
                margin="6px"
                color="white"
                bgColor={currentColor}
                text="Assign Product"
                borderRadius="10px"
                onClick={handleViewEmployeesClick2}
              />
            </Col>
          )}

          {userPermID.includes(5025) && (
            <>
              {" "}
              <Col md="auto" style={{ padding: "0" }}>
                <Button
                  margin="6px"
                  color="white"
                  bgColor={currentColor}
                  text="View Purchase"
                  borderRadius="10px"
                  onClick={handleViewEmployeesClick4}
                />
              </Col>{" "}
              <Col md="auto" style={{ padding: "0" }}>
                <Button
                  margin="6px"
                  color="white"
                  bgColor={currentColor}
                  text="Print Ledger"
                  borderRadius="10px"
                  onClick={handlePrintLedgerClick}
                />
              </Col>
            </>
          )}
        </Row>
      </Container>
      {loading || promiseInProgress ? (
        <LoadingIndicator />
      ) : (
        <>
          <GridComponent
            className="custom-grid"
            dataSource={AllSuppliers}
            allowPaging={true}
            pageSettings={{
              pageSize: 10,
              pageSizes: [10, 16, 48, 100, "All"],
            }}
            enablePersistence={true}
            height="calc(62vh - 60px)"
            allowSorting
            allowResizing
            toolbar={["Search"]}
            rowSelected={handleRowSelected}
            rowHeight={36}
            recordDoubleClick={
              userPermID.includes(5025) && handleViewSupplierClick
            }
          >
            <ColumnsDirective>
              {customersGrid.map((item, index) => (
                <ColumnDirective key={index} {...item} />
              ))}
            </ColumnsDirective>
            <Inject
              services={[Resize, Page, Toolbar, Selection, Edit, Sort, Filter]}
            />
          </GridComponent>
        </>
      )}
    </div>
  );
};

export default Supplier;
